// extracted by mini-css-extract-plugin
export var content = "_dv-3";
export var list = "_dv-4";
export var settingsContent = "_dv-7";
export var settingsPanel = "_dv-8";
export var state = "_dv-6";
export var triggerBadge = "_dv-2";
export var triggerButton = "_dv-1";
export var triggerShell = "_dv-0";
export var unreadDot = "_dv-5";